import SlhNavigationItem from "./src/item";
import type {
  SlhNavigationItemInterface,
  SlhNavigationItemType,
} from "./src/item.interface";
import { ITEM_CLICK } from "./src/item.constants";

export type { SlhNavigationItemType, SlhNavigationItemInterface };
export { SlhNavigationItem, ITEM_CLICK };
